import * as Sentry from '@sentry/browser'
import ls from './localStorage'

const { appData, id = 'test', server = 'localhost' } = ls.getItem('appData') || {}

if (window.location.protocol === 'https:') {
  Sentry.init({ dsn: 'https://ffaa75922292469495f9038ecc42af84@sentry.io/3474067' })
}

/**
 * Retorna o prefixo para montar os requests na api
 */
const isTesting = window.location.search.indexOf('test=true') !== -1
export function getPrefix() {
  if (process.env.NODE_ENV === 'production') {
    return ''
  }

  if (!id) {
    throw new Error('use changeAppData(widgetDomain, server)')
  }

  if (server === 'localhost') {
    return `http://localhost:3000/dev/productfinder/${id}`
  }

  return `https://${id}.aquiperto.app`
}

const serverOptions = [
  'localhost',
  'ondetem.app', // x
  'aquiperto.app', // stage
  'pertinhodemim.com', // prod
  'pertinhodemim.app', // dev
]

/**
 * @param {string} id widgetDomain
 * @param {string} server one of serverOptions
 */
async function changeAppData(id, server = 'localhost') {
  if (!serverOptions.includes(server)) {
    throw new Error(`Precisa ser uma das opções: ${serverOptions}`)
  }

  const url =
    server === 'localhost' ? `http://localhost:3000/dev/productfinder/${id}/widget` : `https://${id}.${server}/widget`

  try {
    const response = await fetch(url)
    const { company } = await response.json()

    ls.setItem('appData', { appData: company, id, server })
    window.location.reload()
  } catch (error) {
    console.error('Error fetch widgetDomain', error.message)
  }
}

const defaultWidgetConfig = {
  searchPlaceholder: 'Busque conhecimento',
  colorPrimary: '#fffff',
  featured: [
    { limitDate: null, gtin: '789611000790', type: 'default', order: 0 },
    { limitDate: '2019-11-01', gtin: '7898139872864', type: 'default', order: 1 },
    { limitDate: null, gtin: '789834432171', type: 'default', order: 2 },
  ],
  brandName: 'GOFIND.ONLINE',
  gtag: '3',
  buyOnline: 'fixedLink',
  fixedLink: 'http://www.google.com',
  anyProducts: 'footer',
  hideProductsList: false,
  ageGateMessage: 'Teste',
  citysAllowedRappi: ['São Paulo-SP'],
  hideRetailButton: false,
  buyWithRappi: true,
  ageGate: false,
  ageGateRedirect: 'http://google.com',
  cnpj: '23809139000186',
  availabilityTimeFactor: 1,
  storesNameViewFormat: 'none',
  language: 'pt-BR',
}

window.appData = window.appData || appData || defaultWidgetConfig

// injeta no window para poder invokar do console
window.changeAppData = changeAppData

export const env = {
  PREFIX: getPrefix(),
  HERE_REST_APIKEY: 'JZhfLnu2glAgScMGP_C5aQmgE-KDqH7cQbSkImxq5F8',
  TEST_MODE: isTesting,
}
